import { render, staticRenderFns } from "./Cyfb.vue?vue&type=template&id=fd60a238"
import script from "./Cyfb.vue?vue&type=script&lang=js"
export * from "./Cyfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports